import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ReservationList = Loadable(
  lazy(() => import("features/reservation/components/List"))
);

const routes = {
  path: "reservation",
  children: [{ path: "", element: <ReservationList /> }],
};

export default routes;
